import { dateFormatOptionsMap } from './dateFormatOptions';
import { SupportedLocalizedDateTimeFormat } from './SupportedLocalizedDateTimeFormat';
var intlDateFormatterMap = new Map();
/**
 * @param officeMarket - The locale to formate the DateTime in
 * @param format - The format of the DateTime
 * @returns - A Map that will optimally instantiate and cache formatters for subsequent use.
 */
export var getIntlDateFormatter = function (officeMarket, format) {
    if (format && intlDateFormatterMap.has(format)) {
        return intlDateFormatterMap;
    }
    if (format) {
        try {
            if ('Intl' in window) {
                intlDateFormatterMap.set(format, new Intl.DateTimeFormat(officeMarket, dateFormatOptionsMap.get(format)));
            }
            dateFormatOptionsMap.delete(format);
        }
        catch (e) { }
    }
    else if (intlDateFormatterMap.has(SupportedLocalizedDateTimeFormat.Default)) {
        return intlDateFormatterMap;
    }
    else {
        intlDateFormatterMap.set(SupportedLocalizedDateTimeFormat.Default, new Intl.DateTimeFormat(officeMarket));
    }
    return intlDateFormatterMap;
};
//# sourceMappingURL=getIntlDateFormatterMap.js.map